/*
document.addEventListener('DOMContentLoaded', function() {
    var menuItems = document.querySelectorAll('.menu-lv-item.has-megamenu');
    var timer;

    menuItems.forEach(function(item) {
        var dropdown = item.querySelector('.menu-dropdown');

        item.addEventListener('mouseover', function() {
            timer = setTimeout(function() {
                var dropdown = item.querySelector('.menu-dropdown');
                dropdown.classList.add('active');
            }, 500);
        });

        dropdown.addEventListener('mouseover', function() {
            dropdown.classList.add('active');
        });

        item.addEventListener('mouseout', function() {
            clearTimeout(timer);
            var dropdown = item.querySelector('.menu-dropdown');
            dropdown.classList.remove('active');
        });

        dropdown.addEventListener('mouseout', function() {
            clearTimeout(timer);
            dropdown.classList.remove('active');
        });
    });
});

*/

document.addEventListener('DOMContentLoaded', function () {
    const menuItems = document.querySelectorAll('.menu-lv-item.has-megamenu');

    menuItems.forEach(function (item) {
        const dropdown = item.querySelector('.menu-dropdown');

        if (!dropdown) {
            return;
        }

        let openTimer;
        let closeTimer;

        function openMegaMenu() {
            clearTimeout(closeTimer);

            openTimer = setTimeout(function () {
                dropdown.classList.add('active');
            }, 500);
        }

        function keepMegaMenuOpen() {
            clearTimeout(openTimer);
            clearTimeout(closeTimer);
            dropdown.classList.add('active');
        }

        function closeMegaMenu() {
            clearTimeout(openTimer);
            clearTimeout(closeTimer);

            closeTimer = setTimeout(function () {
                dropdown.classList.remove('active');
            }, 300);
        }

        item.addEventListener('mouseenter', openMegaMenu);
        item.addEventListener('mouseleave', closeMegaMenu);

        dropdown.addEventListener('mouseenter', keepMegaMenuOpen);
        dropdown.addEventListener('mouseleave', closeMegaMenu);
    });
});


document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.halo-sidebar_menu .menu-lv-1__action').forEach(function (link) {
        link.addEventListener('click', function (event) {
            event.preventDefault();
        });
    });
});


//Login Redirect
document.addEventListener('click', function (event) {
    var loginLink = event.target.closest('[data-login-return]');

    if (!loginLink) {
        return;
    }

    event.preventDefault();

    var returnTo =
        window.location.pathname +
        window.location.search +
        window.location.hash;

    var loginUrl =
        '/customer_authentication/login?return_to=' +
        encodeURIComponent(returnTo);

    window.location.href = loginUrl;
});